import type { ReactNode } from "react";

interface ChipProps {
    isActive: boolean;
    onClick: () => void;
    icon: ReactNode;
}

export const Chip = ({ isActive, onClick, icon }: ChipProps) => {
    return (
        <div
            className={`grid place-items-center ${isActive ? "bg-white dark:bg-darkSurface-300" : "bg-transparent"} w-20 h-10 rounded-xl ${
                isActive ? "shadow-[0px_2px_15px_rgba(26,26,26,0.15)]" : ""
            }`}
            onClick={onClick}
        >
            {icon}
        </div>
    );
};
